import HomePage from "../modules/homepage/Index";
import AnalyticsPage from "../modules/analytics/Index";
import SettingsPage from "../modules/settings/Index";
import ZohoPage from "../modules/zoho/Index";
import RequestPage from "../modules/requests/Index";
import Utilities from "../modules/utilities/Index";
import LogoutHandler from "../common/LogoutHandler";

export interface Route {
  path: string;
  label: string;
  component?: React.FC;
  children?: Route[];
}

export const myRoutes: Route[] = [
  { path: "/", label: "Home", component: HomePage },
  { path: "/analytics", label: "Analytics", component: AnalyticsPage },
  { path: "/raise-request", label: "Raise Request", component: RequestPage },
  {
    path: "/zoho-projects",
    label: "Zoho Projects",
    component: ZohoPage,
  },
  { path: "/utilities", label: "Utilities", component: Utilities },
  {
    path: "/settings",
    label: "Settings",
    component: SettingsPage,
  },
  {
    path: "/logout",
    label: "Logout",
    component: LogoutHandler,
  },
];
